import { ArrowLeft } from "lucide-react";

// Neo-Brutalist shared primitives (border-2 black, flat shadow, serif/mono).
export function VanHeader({ title, sub, onBack, step, testid }) {
  return (
    <header className="shrink-0 px-4 pt-4 pb-3 border-b-2 border-black bg-[#FDFBF7] flex items-center gap-3" data-testid={testid}>
      {onBack && (
        <button onClick={onBack} data-testid="van-back-btn" aria-label="Back"
          className="w-9 h-9 rounded-lg bg-white border-2 border-black grid place-items-center shadow-[3px_3px_0px_#000] active:translate-x-[2px] active:translate-y-[2px] active:shadow-none">
          <ArrowLeft size={17} className="text-black" />
        </button>
      )}
      <div className="leading-none flex-1 min-w-0">
        {sub && <p className="font-mono text-[9px] uppercase tracking-[0.24em] text-black/60 truncate">{sub}</p>}
        <h1 className="font-serif text-2xl text-black truncate">{title}</h1>
      </div>
      {step && <span className="font-mono text-[10px] font-black uppercase bg-black text-[#FDFBF7] px-2 py-1 rounded border-2 border-black">{step}</span>}
    </header>
  );
}

export function NCard({ children, className = "", ...rest }) {
  return (
    <div className={`bg-white border-2 border-black rounded-xl shadow-[4px_4px_0px_#000] ${className}`} {...rest}>
      {children}
    </div>
  );
}

export function MonoBadge({ children, tone = "default", className = "" }) {
  const tones = {
    default: "bg-white text-black", gold: "bg-[#D4AF37] text-black",
    dark: "bg-black text-[#FDFBF7]", warn: "bg-[#DC2626] text-white", ok: "bg-[#98FFB6] text-black",
  };
  return (
    <span className={`inline-flex items-center gap-1 font-mono text-[9px] font-black uppercase tracking-wider px-2 py-0.5 rounded border-2 border-black ${tones[tone]} ${className}`}>
      {children}
    </span>
  );
}

export function NBtn({ children, onClick, variant = "primary", disabled, testid, className = "" }) {
  const base = "w-full font-mono text-xs font-black uppercase tracking-widest py-3 rounded-xl border-2 border-black flex items-center justify-center gap-2 transition-transform disabled:opacity-50";
  const variants = {
    primary: "bg-black text-[#FDFBF7] shadow-[4px_4px_0px_#000] active:translate-x-[3px] active:translate-y-[3px] active:shadow-none",
    gold: "bg-[#D4AF37] text-black shadow-[4px_4px_0px_#000] active:translate-x-[3px] active:translate-y-[3px] active:shadow-none",
    ghost: "bg-white text-black shadow-[3px_3px_0px_#000] active:translate-x-[2px] active:translate-y-[2px] active:shadow-none",
  };
  return (
    <button onClick={onClick} disabled={disabled} data-testid={testid} className={`${base} ${variants[variant]} ${className}`}>
      {children}
    </button>
  );
}

export function SegGroup({ options, value, onChange, testid }) {
  return (
    <div className="grid gap-1.5" style={{ gridTemplateColumns: `repeat(${options.length}, minmax(0,1fr))` }} data-testid={testid}>
      {options.map((o) => {
        const val = typeof o === "string" ? o : o.value;
        const label = typeof o === "string" ? o : o.label;
        const on = value === val;
        return (
          <button key={val} onClick={() => onChange(val)} data-testid={`${testid}-${val}`}
            className={`font-mono text-[10px] font-black uppercase tracking-wide py-2 rounded-lg border-2 border-black ${on ? "bg-black text-[#FDFBF7] shadow-[3px_3px_0px_#000]" : "bg-white text-black"}`}>
            {label}
          </button>
        );
      })}
    </div>
  );
}

export function Chip({ label, on, onClick, testid }) {
  return (
    <button onClick={onClick} data-testid={testid}
      className={`font-mono text-[10px] font-black uppercase tracking-wide px-3 py-2 rounded-full border-2 border-black ${on ? "bg-[#D4AF37] text-black shadow-[2px_2px_0px_#000]" : "bg-white text-black/70"}`}>
      {label}
    </button>
  );
}
